import React from 'react';
import { Button, ButtonProps } from '@cp/ds/src/components/button';
import { CloseIcon } from '@cp/ds/src/icons/close';
import { useCatalogFilterClose } from '../model';

export const CatalogFilterCloseButton: React.FC<ButtonProps> = (props) => {
  const close = useCatalogFilterClose();

  return (
    <Button color="white" onClick={close} size="small" square {...props}>
      <CloseIcon />
    </Button>
  );
};
